import { render } from "./dicTree.vue?vue&type=template&id=33470a80&scoped=true"
import script from "./dicTree.vue?vue&type=script&lang=js"
export * from "./dicTree.vue?vue&type=script&lang=js"

import "./dicTree.vue?vue&type=style&index=0&id=33470a80&scoped=true&lang=css"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33470a80"]])

export default __exports__